


















































































































































































































































































import Proxyable from '@/mixins/proxyable';
import {
  WorkflowFormFieldTypeEnum,
  IWorkflowFormFieldData,
  IWorkflowFormSectionData,
  WorkflowFormFieldType,
  IWorkflowFormFieldType
} from '@/models';
import mixins from '@/utils/mixins';
import { PropType } from 'vue';
import { PropertyTabs } from './workflowFormBuilderTab.constants';
import { extractTextFromHtml } from '@/utils/helpers';

import QuillEditor from '@/components/common/QuillEditor.vue';

const baseMixins = mixins(Proxyable);

interface Options extends InstanceType<typeof baseMixins> {
  // TODO: LH - 2025-08-16 - Should change name to isPublished as this is not exactly disabling the form
  isFormDisabled: boolean;
  internalValue: IWorkflowFormSectionData;
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'WorkflowFormBuilderGeneralTab',

    components: {
      QuillEditor
    },

    props: {
      value: Object as PropType<IWorkflowFormSectionData>,
      selectedFieldIndex: Number
    },

    inject: {
      isFormDisabled: {
        default: false
      }
    },

    data() {
      return {
        WorkflowFormFieldTypeEnum,
        PropertyTabs,

        widthOptions: [
          { display_name: 'Quarter width', value: 3 },
          { display_name: 'Half width', value: 6 },
          { display_name: 'Full width', value: 12 }
        ]
      };
    },

    computed: {
      fieldTypes(): IWorkflowFormFieldType[] {
        return WorkflowFormFieldType.getWorkflowFormFieldTypeList();
      },

      canAddOptionsAndTodos(): boolean {
        let canAdd = false;

        const FieldOptionTypesList = [
          WorkflowFormFieldTypeEnum.Checkbox,
          WorkflowFormFieldTypeEnum.Radiobutton,
          WorkflowFormFieldTypeEnum.Combobox
        ];

        canAdd = FieldOptionTypesList.includes(
          (this.internalValue.section_fields[this.selectedFieldIndex]
            .field_template as IWorkflowFormFieldData).type
        );

        return canAdd;
      },

      canAddCalculation(): boolean {
        return (
          WorkflowFormFieldTypeEnum.CalculationField ===
          (this.internalValue.section_fields[this.selectedFieldIndex]
            .field_template as IWorkflowFormFieldData).type
        );
      },

      canAddUrgencyThreshold(): boolean {
        return (
          WorkflowFormFieldTypeEnum.DatePicker ===
          (this.internalValue.section_fields[this.selectedFieldIndex]
            .field_template as IWorkflowFormFieldData).type
        );
      },

      isTemplateField(): boolean {
        return (
          WorkflowFormFieldTypeEnum.TemplateField ===
          (this.internalValue.section_fields[this.selectedFieldIndex]
            .field_template as IWorkflowFormFieldData).type
        );
      },

      sectionTemplateFields(): IWorkflowFormFieldData[] {
        return (this.internalValue as IWorkflowFormSectionData).section_fields
          .filter(
            sectionField =>
              (sectionField.field_template as IWorkflowFormFieldData).type ===
              WorkflowFormFieldTypeEnum.TemplateField
          )
          .map(
            sectionField =>
              sectionField.field_template as IWorkflowFormFieldData
          );
      },

      fieldDisplayType(): string {
        return this.fieldTypes.find(
          type =>
            type.value ==
            this.internalValue.section_fields[this.selectedFieldIndex]
              .field_template.type
        )!.text;
      }
    },

    methods: {
      extractTextFromHtml,

      goToTabWindow(tab: PropertyTabs) {
        this.$emit('goToTabWindow', tab);
      },

      save() {
        this.$emit('save');
      },

      close() {
        this.$emit('close');
      }
    }
  });
